import { Link } from 'react-router-dom';
import { NAV_LINKS } from './types';

interface NavLinksProps {
  isActive: (path: string) => boolean;
}

/** Desktop navigation links with active state and hover animation */
export function NavLinks({ isActive }: NavLinksProps) {
  return (
    <>
      {NAV_LINKS.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className={`relative text-sm font-medium transition-all duration-300 group py-2 px-3 rounded-md ${
            isActive(link.to)
              ? 'text-[#FF1493] bg-pink-50/50'
              : 'text-gray-600 hover:text-[#FF1493] hover:bg-pink-50/30'
          }`}
        >
          <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-[#FF1493] transition-all duration-300 group-hover:w-full" />
          <span className="relative z-10 transition-transform duration-300 group-hover:translate-y-[-1px]">{link.label}</span>
        </Link>
      ))}
    </>
  );
}
